<template>
  <section class="form__content">
    <h3>3. {{ $t('registration.title') }}</h3>

    <v-form v-model="formValidation">
      <v-text-field v-if="hasRegistrationEntitiesList"
                    :value="registrationEntity"
                    :label="$t('registration.registrationEntity')"
                    @input="$emit('update:registrationEntity', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-select v-else
                :value="registrationEntity"
                :label="$t('registration.registrationEntity')"
                @change="$emit('update:registrationEntity', $event)"
                required
                :rules="[v => !!v || $t('error.required')]"
                :items="registrationEntitiesList"
      />

      <p v-if="!hasRegistrationEntitiesList">
        {{ $t('registration.registrationEntityExplication') }}
      </p>

      <v-text-field :value="registrationManager"
                    :label="$t('registration.registrationManager')"
                    @input="$emit('update:registrationManager', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="registrationReferent"
                    :label="$t('registration.registrationReferent')"
                    @input="$emit('update:registrationReferent', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="registrationAddress"
                    :label="$t('registration.registrationAddress')"
                    @input="$emit('update:registrationAddress', $event)"
                    required
                    :rules="[v => !!v || $t('error.required')]"
      />
      <v-text-field :value="mail"
                    :label="$t('registration.registrationEmail')"
                    @input="$emit('update:mail', $event)"
                    required
                    :rules="[v => !!v || $t('error.required'), emailValidation]"
                    type="email"
      />
      <v-text-field :value="registrationPhone"
                    :label="$t('registration.registrationPhone')"
                    @input="$emit('update:registrationPhone', $event)"
                    type="tel"
      />
    </v-form>
  </section>
</template>

<script>
import validationMixin from '@/mixins/validationMixin'

export default {
  name: 'registration',

  mixins: [validationMixin],

  props: {
    valid: {
      required: false,
    },
    registrationAddress: {
      required: true,
    },
    mail: {
      required: true,
    },
    registrationEntity: {
      required: true,
    },
    registrationEntitiesList: {
      required: false,
      default: null,
    },
    registrationManager: {
      required: true,
    },
    registrationPhone: {
      required: true,
    },
    registrationReferent: {
      required: true,
    },
  },

  data: () => ({
    formValidation: false,
  }),

  computed: {
    hasRegistrationEntitiesList () {
      return this.registrationEntitiesList === null
    },
  },

  watch: {
    formValidation () {
      this.$emit('update:valid', this.formValidation)
    },
  },
}
</script>
